import React, { useCallback } from 'react';
import cn from 'classnames';

import { useIsMobile } from 'hooks';
import type { Analytics } from 'services/analytics';
import Icon from '../Icon';

import checkDesk from 'assets/svg/check.svg';
import chevron from 'assets/svg/chevron.svg';
import './CheckBox.scss';

interface Props {
    checked?: boolean;
    reversed?: boolean;
    onChange?: (event: React.SyntheticEvent) => void;
    analytics?: Analytics;
}

const CheckBox: React.FC<Props> = ({
    checked = false,
    reversed = false,
    onChange,
    analytics,
}) => {
    const check = useIsMobile() ? chevron : checkDesk;

    const handleCheckedChange = useCallback(
        (event: React.SyntheticEvent) => {
            if (!onChange) return;

            onChange(event);
        },
        [onChange]
    );

    return (
        <div
            className="__app-CheckBox-container"
            styleName={cn('container', {
                checked,
                reversed,
            })}
            onClick={handleCheckedChange}
            data-category={analytics?.category}
            data-action={analytics?.action}
        >
            {checked && <Icon styleName="icon" glyph={check} />}
        </div>
    );
};

export default CheckBox;
